/**
 * 웹뷰 콘텐츠(ably-webview-react)와 주고받는 쿼리 파라미터 키.
 *
 * 콘텐츠 저장소와의 **계약**이므로 값을 바꾸면 양쪽을 함께 고쳐야 한다.
 */

/**
 * 이 페이지가 앱(또는 RN-Web) 안에 임베드되어 열렸음을 알리는 마커.
 *
 * 콘텐츠 쪽은 원래 `window.self !== window.top` 으로 판별했는데 그 값이 기대와 다르게
 * 나오는 케이스가 있어(임베드가 아닌 새 탭 경로 등) 호스트가 명시적으로 알려준다.
 * 프레임 구조 추측보다 호출 주체가 선언하는 쪽이 신뢰할 수 있다.
 */
export const EMBEDDED_WEB_QUERY_KEY = 'embedded_web';

/** 콘텐츠가 앱 레이아웃(웹 header/footer 제거)으로 렌더하도록 알리는 마커. */
export const GLOBAL_LAYOUT_QUERY_KEY = 'global_layout';
export const GLOBAL_LAYOUT_APP = 'app';
